import React from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
import useDamageTypesLogic from "./useDamageTypesLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  { field: "name", label: "Name", allowSorting: true },
];

const DamageTypesPage = () => {
  const { addRoles, deleteRoles, editRoles, initFields, apiRoute } =
    useDamageTypesLogic();
  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Damage Types." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        // this one is used to fetch filter options , so i can do a single backend function to fetch for all pages
        tableNameInDb="damage_type"
        //
        apiRoute={apiRoute}
        columns={columns}
        fields={initFields}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        enhancedTable={true}
      />
    </div>
  );
};

export default DamageTypesPage;
